import React from "react";
import { I18n } from "react-redux-i18n";
import _ from "../../../shared/utils/ObjectUtils";
import PropTypes from "prop-types";
import SelectField from "../../../shared/components/fields/selectField/SelectField";

const InterfaceSelectorConfigField = ({
    formData: {
        entityId = {},
        terminalId = {},
        interfaceIds = {}
    },
    handleFieldChange,
    entityList,
    terminalsList,
    interfaceList,
}) => {
    return (
            <div className="row mt-3">
                <SelectField
                    label={I18n.t("dashboard.widgets.formsFields.entity")}
                    value={parseInt(entityId.value)}
                    options={entityList}
                    error={entityId.error}
                    handleFieldChange={value => handleFieldChange("entityId", value)}
                    classes="selector"
                    isClearable={false}
                    width={4}
                />
                <SelectField
                    label={I18n.t("dashboard.widgets.formsFields.terminal")}
                    value={parseInt(terminalId.value)}
                    options={terminalsList}
                    error={terminalId.error}
                    handleFieldChange={value => handleFieldChange("terminalId", value)}
                    disabled={_.isNilOrEmpty(entityId.value)}
                    classes="selector"
                    isClearable={false}
                    width={4}
                />
                <SelectField
                    label={I18n.t("dashboard.widgets.formsFields.terminalInterface")}
                    value={parseInt(interfaceIds.value)}
                    options={interfaceList}
                    error={interfaceIds.error}
                    handleFieldChange={value => handleFieldChange("interfaceIds", value)}
                    disabled={_.isNilOrEmpty(entityId.value)}
                    classes="selector"
                    isClearable={false}
                    width={4}
                />
            </div>
    );
};

InterfaceSelectorConfigField.propTypes = {
    value: PropTypes.string,
    detailsForm: PropTypes.object,
    handleFieldChange: PropTypes.func,
    terminalsList: PropTypes.array,
    entityList: PropTypes.array
};

export default InterfaceSelectorConfigField;